import React from 'react';
import api from '../../services/api';
import { useLocation, useNavigate } from 'react-router-dom';
import FlightForm from './FlightForm';

const CreateFlight = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedIds = location.state?.selectedIds || [];

  const handleSubmit = async (formData) => {
    try {
      // Prepare dates for API (simplified with optional chaining)
      const prepareDate = (date) => date ? new Date(date).toISOString() : null;
  
      const flightData = {
        ...formData,
        departDate: prepareDate(formData.departDate),
        arrivalDate: prepareDate(formData.arrivalDate),
      };
  
      const response = await api.post('/flights', {
        Flight: flightData,
        SelectedIds: selectedIds
      });
  
      // Success handling
      navigate("/flights/flightlist", {state: {    success: true, flightId: response.data?.id }});
  
    } catch (error) {
      console.error('Flight creation failed:', {
        error: error.response?.data || error.message,
        status: error.response?.status
      });
  
      const errorMessage = error.response?.data?.message 
        || error.response?.data?.title 
        || error.message 
        || 'Failed to create flight';
    }
  };

  return <FlightForm onSubmit={handleSubmit} selectedIds={selectedIds} />;
};

export default CreateFlight;